import styled, { css } from 'styled-components';
import React from 'react';
import {
  AnchorLink,
  SVGIcon,
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

const getBorderColor = (props) => {
  if (props.isDragReject || props.error) {
    return props.theme['color.redLight'];
  }
  if (props.isDragActive) {
    return props.theme['color.blueDark'];
  }
  if (props.acceptedFilesLength > 0) {
    return 'transparent';
  }
  return props.theme['color.input.border'];
};

export const DragHighlightCss = css`
  border-width: 2px;
  border-style: dashed;
  border-color: ${(props) => getBorderColor(props)};
`;

const DisplayProperty = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const FontProperty = `
  font-size: 14px;
  font-weight: normal;
  font-family: Open Sans;
`;

export const DropzoneContainer = styled.div`
  ${DragHighlightCss};
  ${DisplayProperty};
  margin-top: 6px;
  border-radius: 4px;
  background-color: ${(props) => {
    if (props.isDragReject || props.error) {
      return 'rgba(249, 97, 85, 0.15)';
    } else if (!props.isDragActive) {
      return props.theme.themeId === 'dark'
        ? props.theme['color.input.background']
        : props.theme['color.greyLight'];
    }
    return 'rgba(33, 150, 243, 0.1)';
  }};
  height: 120px;
  ${(props) => props.validationError && `
    border-color: ${props.theme['color.redLight']};
    border-style: solid;
  `}
`;

export const DragAreaText = styled.p`
  margin: 0px;
`;

export const DragAreaInput = styled.input`
  background: ${(props) => props.theme['color.text.light']};
`;

export const DragAreaLink = styled(AnchorLink)`
  text-decoration-line: underline;
  span {
    border-bottom: none;
    box-shadow: none;
  }
`;

export const DragAreaDiv = styled.div`
  ${DisplayProperty};
  ${FontProperty};
`;

export const ErrorInfo = styled.p`
  display: flex;
  flex-direction: row;
  transition: all 0.3s ease;
  font-size: 14px;
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.redLight']
      : props.theme['color.redDark']};
  margin: 0;
  overflow: hidden;
  padding-top: 6px;

  & > svg {
    margin-right: 6px;
    width: 20px;
    height: 20px;
  }
`;
export const DroppedFileName = styled.div`
  ${DisplayProperty};
  justify-content: space-between;
  flex-direction: row;
  padding: 20px;
  width: 100%;
`;

export const FileIcon = styled(SVGIcon)`
  opacity: 0.6;
  margin-right: 5px;
`;

export const CancelButton = styled(Button)`
  opacity: 0.8;
`;

export const FileNameWrapper = styled.p`
  display: flex;
  width: 80%;
`;

export const GreyButton = styled(({ iconName, ...rest }) => (
  <Button iconOnly grey height={24} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
))`
  i {
    color: ${(props) => props.theme['color.redLight']};
  }
`;

export const ValidationErrorLabel = styled.div`
  display: inline-block;
  text-align: center;
`;

export const ValidationErrorIcon = styled.div`
  display: inline-block;
  right: 0;
  position: absolute;
  top: 5px;
`;

export const ValidationErrorMsg = styled.div`
  position: relative;
`;

export const ValidationErrorTogglePanel = styled.div`
  border-width: 2px;
  padding: 5px;
  border-style: dashed;
  border-color: ${(props) => props.theme['color.redLight']};
  border-radius: 4px;
  height: 100px;
  background-color: ${(props) => props.theme.themeId === 'dark'
    ? props.theme['color.input.background']
    : props.theme['color.greyLight']};
  overflow-y: auto;
`;

export const ExpandButton = styled(
  ({ expanded, ...rest }) => <GreyButton iconName={expanded ? 'expand_less' : 'expand_more'} {...rest} />
)`
  margin-right: 5px;
`;

